const { DateTime } = require('luxon');

function parseDateTimeFromString(inputString) {
  try {
    // Map common time zone abbreviations to IANA time zones
    const timeZoneMap = {
      IST: 'Asia/Kolkata',
      PST: 'America/Los_Angeles',
      EST: 'America/New_York',
      CST: 'America/Chicago',
      MST: 'America/Denver',
      GMT: 'Etc/GMT',
      UTC: 'Etc/UTC',
    };

    // Extract potential time zone abbreviation and replace it with IANA zone
    let ianaZone = null;
    const tzMatch = inputString.match(/\b[A-Z]{2,4}\b/);
    if (tzMatch && timeZoneMap[tzMatch[0]]) {
      ianaZone = timeZoneMap[tzMatch[0]];
      inputString = inputString.replace(tzMatch[0], '').trim(); // Remove the timezone for parsing
    }

    const formats = [
      DateTime.ISO,
      DateTime.RFC2822,
      'd-LLL-yy', // e.g., "24-Oct-24"
      'yyyy-LL-dd', // e.g., "2024-01-02"
      'yyyy-L-dd', // e.g., "2024-1-02"
      'yyyy LLL dd', // e.g., "2024 Jan 02"
      'dd-LL-yyyy', // e.g., "02-01-2024"
      'LL/dd/yyyy', // e.g., "01/02/2024"
      'yyyy/LL/dd', // e.g., "2024/01/02"
      'L/d/yyyy', // e.g., "1/2/2024"
      'd/L/yyyy', // e.g., "2/1/2024"
      'yyyyLLdd', // e.g., "20240102"
      'dd.LL.yyyy', // e.g., "02.01.2024"
      'LL-dd-yyyy', // e.g., "01-02-2024"
      // Adding time formats
      'yyyy-LL-dd HH:mm', // e.g., "2024-01-02 15:00"
      'dd-LL-yyyy HH:mm:ss', // e.g., "25-11-2024 18:30:0"
      'yyyy-LL-dd HH:mm:ss', // e.g., "2024-01-02 15:00:00"
      'yyyy-LL-dd\'T\'HH:mm:ss', // e.g., "2024-01-02T15:00:00"
      'yyyy-LL-dd\'T\'HH:mm:ss.SSS', // e.g., "2024-01-02T15:00:00.123"
      'HH:mm', // e.g., "15:00"
      'HH:mm:ss', // e.g., "15:00:00"
      'HH:mm:ss.SSS', // e.g., "15:00:00.123"
      'h:mm a', // e.g., "3:00 PM"
      'h:mm:ss a', // e.g., "3:00:00 PM"
    ];

    for (let format of formats) {
      let dt;
      if (format === DateTime.ISO || format === DateTime.RFC2822) {
        dt = format === DateTime.ISO ? DateTime.fromISO(inputString) : DateTime.fromRFC2822(inputString);
      } else {
        dt = DateTime.fromFormat(inputString, format);
      }

      if (dt.isValid) {
        return ianaZone ? dt.setZone(ianaZone) : dt;
      }
    }

    return null;
  } catch (error) {
    return null;
  }
}

module.exports = { parseDateTimeFromString };
